/* TULMERIA — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function observer() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.dispatchEvent(new CustomEvent('tl:in'));
        io.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    return io;
  }

  /* Titulares que se escriben palabra a palabra */
  function initSplit(root) {
    root.querySelectorAll('.tl-split:not([data-split])').forEach(function (el) {
      el.setAttribute('data-split', '');
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement('span'); w.className = 'tl-w';
              var s = document.createElement('span'); s.style.setProperty('--i', i++); s.textContent = part;
              w.appendChild(s); frag.appendChild(w);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            walk(child);
          }
        });
      })(el);
    });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.tl-reveal, .tl-split, .tl-mask, [data-tl-observe]');
    els.forEach(function (el) {
      if (reduce) { el.classList.add('is-in'); return; }
      observer().observe(el);
    });
  }

  /* Cifras que cuentan al aparecer */
  function initCount(root) {
    root.querySelectorAll('[data-tl-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-tl-count')) || 0;
      var dec = (String(target).split('.')[1] || '').length;
      if (reduce) { el.textContent = target.toFixed(dec).replace('.', ','); return; }
      el.textContent = (0).toFixed(dec).replace('.', ',');
      var host = el.closest('.tl-reveal') || el;
      function run() {
        var t0 = null, dur = 1800;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var v = target * (1 - Math.pow(1 - p, 4));
          el.textContent = v.toFixed(dec).replace('.', ',');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if (host.classList.contains('is-in')) run();
      else { host.addEventListener('tl:in', run, { once: true }); if (host === el) observer().observe(el); }
    });
  }

  /* Comparador antes / después */
  function initCompare(root) {
    root.querySelectorAll('.tl-ba').forEach(function (ba) {
      var range = ba.querySelector('.tl-ba__range');
      if (!range) return;
      function set(v) { ba.style.setProperty('--pos', v + '%'); }
      range.addEventListener('input', function () { ba.dataset.touched = '1'; set(range.value); });
      set(range.value);
      if (reduce) return;
      var host = ba.closest('.tl-mask') || ba;
      function hint() {
        var t0 = null, dur = 2600, start = parseFloat(range.value);
        function step(t) {
          if (ba.dataset.touched) return;
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var v = start + Math.sin(p * Math.PI * 2) * 22 * (1 - p);
          range.value = v; set(v);
          if (p < 1) requestAnimationFrame(step);
        }
        setTimeout(function () { requestAnimationFrame(step); }, 900);
      }
      if (host.classList.contains('is-in')) hint(); else host.addEventListener('tl:in', hint, { once: true });
      if (host === ba) observer().observe(ba);
    });
  }

  /* Parallax suave (solo transform) */
  var parEls = [];
  function initParallax(root) {
    if (reduce) return;
    root.querySelectorAll('[data-tl-par]').forEach(function (el) {
      if (parEls.indexOf(el) === -1) parEls.push(el);
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parEls.forEach(function (el) {
        if (!el.isConnected) return;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-tl-par')) || 0;
        var prog = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.setProperty('--tl-par', (prog * k * -1).toFixed(1) + 'px');
      });
      ticking = false;
    });
  }

  /* Selector de colores de la portada */
  function initColors(root) {
    root.querySelectorAll('.tl-colors').forEach(function (sec) {
      var sw = sec.querySelectorAll('.tl-swatch'), imgs = sec.querySelectorAll('.tl-colors__stage img');
      var name = sec.querySelector('.tl-colors__name'), btn = sec.querySelector('[data-tl-colorlink]');
      sw.forEach(function (s, i) {
        s.addEventListener('click', function () {
          sw.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
          imgs.forEach(function (x) { x.classList.remove('is-active'); });
          s.classList.add('is-active'); s.setAttribute('aria-pressed', 'true');
          if (imgs[i]) imgs[i].classList.add('is-active');
          if (name) name.textContent = s.getAttribute('data-name');
          if (btn && s.getAttribute('data-url')) btn.setAttribute('href', s.getAttribute('data-url'));
        });
      });
    });
  }

  /* Acordeones */
  function initAccordion(root) {
    root.querySelectorAll('.tl-acc__q:not([data-ready])').forEach(function (q) {
      q.setAttribute('data-ready', '');
      q.addEventListener('click', function () {
        var item = q.closest('.tl-acc__item');
        var open = !item.classList.contains('is-open');
        if (q.closest('[data-tl-single]')) {
          q.closest('.tl-acc').querySelectorAll('.tl-acc__item.is-open').forEach(function (o) {
            o.classList.remove('is-open'); o.querySelector('.tl-acc__q').setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', open);
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Página de producto */
  function initPdp(root) {
    root.querySelectorAll('[data-tl-pdp]').forEach(function (pdp) {
      var dataEl = pdp.querySelector('[data-tl-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = pdp.querySelector('form[data-tl-form]');
      var idInput = form && form.querySelector('input[name="id"]');
      var priceEl = pdp.querySelector('[data-tl-price]'), compareEl = pdp.querySelector('[data-tl-compare]');
      var saveEl = pdp.querySelector('[data-tl-save]'), addBtn = pdp.querySelector('[data-tl-add]');
      var addLabel = addBtn && addBtn.querySelector('[data-tl-label]');
      var errEl = pdp.querySelector('.tl-pdp__error');
      var main = pdp.querySelector('.tl-pdp__main'), thumbs = pdp.querySelectorAll('.tl-pdp__thumb');
      var sticky = document.querySelector('.tl-sticky-buy[data-for="' + pdp.id + '"]');
      var money = pdp.getAttribute('data-money') || '{{amount_with_comma_separator}} €';

      function fmt(cents) {
        var v = (cents / 100).toFixed(2);
        var withComma = v.replace('.', ',');
        return money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
          .replace(/\{\{\s*amount\s*\}\}/, v)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
      }

      function show(mediaId) {
        if (!main) return;
        var imgs = main.querySelectorAll('img');
        var target = main.querySelector('img[data-media="' + mediaId + '"]');
        if (!target) return;
        imgs.forEach(function (i) { i.classList.remove('is-active'); });
        target.classList.add('is-active');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media') === String(mediaId)); });
        var at = pdp.querySelector('.tl-pdp__thumb.is-active');
        if (at && at.scrollIntoView && window.innerWidth < 750) at.parentElement.scrollTo({ left: at.offsetLeft - 20, behavior: 'smooth' });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-media')); }); });

      // Zoom al pasar el ratón
      if (main && window.matchMedia('(hover: hover)').matches) {
        main.addEventListener('mousemove', function (e) {
          var r = main.getBoundingClientRect();
          main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        });
        main.addEventListener('click', function () { main.classList.toggle('is-zoom'); });
        main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
      }
      // Deslizar en móvil
      if (main) {
        var x0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) < 40) return;
          var list = Array.prototype.slice.call(thumbs), cur = list.findIndex(function (t) { return t.classList.contains('is-active'); });
          var next = list[(cur + (dx < 0 ? 1 : -1) + list.length) % list.length];
          if (next) show(next.getAttribute('data-media'));
        });
      }

      function current() {
        var sel = [];
        pdp.querySelectorAll('.tl-pdp__opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
        });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      }

      function update() {
        var v = current();
        pdp.querySelectorAll('.tl-pdp__opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked'), b = fs.querySelector('legend b');
          if (c && b) b.textContent = c.getAttribute('data-label') || c.value;
        });
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addLabel.textContent = addBtn.getAttribute('data-unavailable'); }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; }
        if (saveEl) {
          if (v.compare_at_price > v.price) { saveEl.hidden = false; saveEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
          else saveEl.hidden = true;
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addLabel.textContent = v.available ? addBtn.getAttribute('data-add') : addBtn.getAttribute('data-soldout');
        }
        if (sticky) {
          var sp = sticky.querySelector('[data-tl-sprice]'); if (sp) sp.textContent = fmt(v.price);
          var sb = sticky.querySelector('.tl-btn'); if (sb) sb.disabled = !v.available;
        }
        if (v.featured_media && v.featured_media.id) show(v.featured_media.id);
        if (history.replaceState && pdp.hasAttribute('data-url-sync')) {
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
        }
      }
      pdp.querySelectorAll('.tl-pdp__opt input').forEach(function (i) { i.addEventListener('change', update); });

      // Cantidad
      var qty = pdp.querySelector('.tl-qty input');
      pdp.querySelectorAll('.tl-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qty.value, 10) || 1) + (b.hasAttribute('data-plus') ? 1 : -1);
          qty.value = Math.max(1, n);
        });
      });

      // Añadir al carrito con el cajón de Dawn
      if (form) {
        form.addEventListener('submit', function (e) {
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!window.fetch || !window.routes || !cart || typeof cart.renderContents !== 'function') return;
          e.preventDefault();
          if (errEl) errEl.textContent = '';
          addBtn.classList.add('is-loading'); addBtn.disabled = true;
          var fd = new FormData(form);
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append('sections_url', window.location.pathname);
          cart.setActiveElement && cart.setActiveElement(document.activeElement);
          fetch(window.routes.cart_add_url, {
            method: 'POST', body: fd,
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) { if (errEl) errEl.textContent = res.description || res.message; return; }
            cart.classList.remove('is-empty');
            cart.renderContents(res);
          }).catch(function () { form.submit(); })
            .finally(function () { addBtn.classList.remove('is-loading'); var v = current(); addBtn.disabled = v ? !v.available : true; });
        });
      }

      // Barra de compra fija en móvil
      if (sticky && addBtn) {
        var sio = new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        sio.observe(addBtn);
        var sbtn = sticky.querySelector('.tl-btn');
        if (sbtn) sbtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
        });
      }

      update();
    });
  }

  /* Opiniones: ver más / ver menos */
  function initReviews(root) {
    root.querySelectorAll('[data-tl-rv-more]:not([data-ready])').forEach(function (btn) {
      btn.setAttribute('data-ready', '');
      var grid = btn.closest('.tl-rv').querySelector('[data-tl-rv]');
      var more = btn.textContent;
      btn.addEventListener('click', function () {
        var open = grid.classList.toggle('is-open');
        btn.textContent = open ? btn.getAttribute('data-less') : more;
        if (open) grid.querySelectorAll('.is-extra').forEach(function (c) { c.classList.add('is-in'); });
        else grid.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function init(root) {
    root = root || document;
    initSplit(root);
    initReveal(root);
    initCount(root);
    initCompare(root);
    initParallax(root);
    initColors(root);
    initAccordion(root);
    initPdp(root);
    initReviews(root);
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
